import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import {
    updateWorksheetPosition,
    updateWorksheetSize,
    updateWorksheetTitle,
} from '../../../store/actions'
import WorksheetEdit from './WorksheetEdit'
import { ElementWrapper } from '../components/ElementWrapper/ElementWrapper'
import { ScoopTextField } from '../../ui'
import styles from './Worksheet.module.scss'

const Worksheet = ({ id, title, initialPosition, initialSize, url, multiProps }) => {
    const dispatch = useDispatch()
    const [inputTitle, setInputTitle] = useState(title) // Local state for the input title
    const [isEditMode, setIsEditMode] = useState(false) // Local state for the edit mode
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    const handleTitleChange = (e) => {
        setInputTitle(e.target.value)
        dispatch(updateWorksheetTitle(id, e.target.value)) // Dispatch the UPDATE_Worksheet_TITLE event
    }

    const updateWorksheetPos = (position) => {
        dispatch(updateWorksheetPosition(id, position))
    }

    const updateWorksheetSz = (size) => {
        dispatch(updateWorksheetSize(id, size))
    }

    return (
        <ElementWrapper
            id={`Worksheet-${id}`}
            key={`Worksheet-${id}`}
            editMode={isEditMode}
            toggleEditMode={setIsEditMode}
            initialSize={initialSize}
            initialPosition={initialPosition}
            updateElementSize={updateWorksheetSz}
            updateElementPosition={updateWorksheetPos}
            {...multiProps}
        >
            {isEditMode && (
                <div className={styles.editMenuWrapper}>
                    <WorksheetEdit
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                        title={title}
                        id={id}
                    />
                </div>
            )}
            <div className={styles.titleContainer}>
                <ScoopTextField
                    placeholder={title}
                    aria-label="description"
                    value={inputTitle}
                    onChange={handleTitleChange}
                    disableMargin
                />
            </div>
            <div className={styles.iframeContainer}>
                <iframe src={url} width="100%" height="100%" frameBorder="0" title={title} />
            </div>
        </ElementWrapper>
    )
}

export default Worksheet
